import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  InputGroup,
  Row
} from 'react-bootstrap'
import {
  BsExclamationCircle,
  BsFillEyeFill,
  BsFillEyeSlashFill
} from 'react-icons/bs'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { updateToken } from '../actions/login.action'
import {
  DATE_LOGIN,
  FOOTER_VERSION,
  PageDefault,
  PROFILE,
  REMEMBER,
  RETOKEN,
  TOKEN
} from '../Constants'
import imgJop from '../images/logo.png'
import imgBanner from '../images/login_page.png'
import UseOrganization from '../hooks/use-org'
import Autocomplete from '../components/custom/autocomplete'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { LoginAPI, checkTokenAPI, versionBackEndAPI } from '../services/login'
import LabelCustom from '../components/label-custom'
import Error_false from '../components/error/error-false'
import Error_500 from '../components/error/error-500'
import moment from 'moment'
import { updateRole } from '../actions/role-org.action'
import fnMapMenu from '../components/layouts/Menu/map-1-menu'
import SwalCustom from '../alert/swal-custom'
import { Divider } from 'antd'
import { MENU_LOGIN } from '../router/routes'
import { useLanguageStage } from '../store/layout'
import { updateAllMenu } from '../actions/allMenu.action'
import { useTranslation } from 'react-i18next'

const schema = yup
  .object({
    username: yup.string().required(),
    password: yup.string().required(),
    orgId: yup.object().required()
  })
  .required()

function LoginPage() {
  const { t } = useTranslation()
  let [searchParams, setSearchParams] = useSearchParams()
  const token = searchParams.get('token')
  const reDirect = searchParams.get('go')
  const [isLoade, setIsLoade] = useState(true)
  const { setLanguageStage } = useLanguageStage()

  useEffect(() => {
    if (token) {
      checkToken()
    } else {
      setIsLoade(false)
    }
  }, [token])
  const checkToken = async () => {
    try {
      if (token) {
        const res = await checkTokenAPI({ token })
        setIsLoade(false)
        if (!res) return
        if (res.status) {
          const profile = res.result[0]
          // const menu = res.role_menus.map((d)=>)
          localStorage.setItem(RETOKEN, res.refreshToken)
          localStorage.setItem(TOKEN, res.accessToken)
          localStorage.setItem(PROFILE, JSON.stringify(res.result[0]))

          dispatch(
            updateToken(res.accessToken, res.refreshToken, res.result[0])
          )
          dispatch(
            updateRole(profile.roles.length > 0 ? profile.roles[0].org_id : 0)
          )

          if (reDirect) {
            navigate(reDirect)
          } else {
            navigate(PageDefault)
          }
        } else {
          Error_false(res)
        }
      }
    } catch (error) {
      setIsLoade(false)
    }
  }
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const navigate = useNavigate()
  const [isLogin, setIsLogin] = React.useState(false)
  const [isShowPassword, setIsShowPassword] = React.useState(false)

  const [apiBack, setApiBack] = useState()

  const dispatch = useDispatch()
  const dataOrgs = UseOrganization()
  useEffect(() => {
    const dataLacal = JSON.parse(localStorage.getItem(REMEMBER) ?? '{}')
    setValue('username', dataLacal?.username ?? '')
    setValue('password', dataLacal?.password ?? '')
    setValue('orgId', dataLacal?.orgId ?? '')
    setValue('remember', dataLacal?.remember ?? false)
  }, [setValue])

  useEffect(() => {
    getVersionBackEnd()
  }, [])

  const getVersionBackEnd = async () => {
    const res = await versionBackEndAPI()
    if (!res) return
    if (res.status) {
      setApiBack(res.result.version)
    }
  }

  const onSubmit = async (data) => {
    try {
      setIsLoade(true)
      setIsLogin(true)
      const res = await LoginAPI({
        username: data.username,
        password: data.password,
        orgId: data.orgId.value
      })
      setIsLoade(false)
      setIsLogin(false)
      if (!res) return
      if (res.status) {
        localStorage.setItem(
          DATE_LOGIN,
          moment(new Date()).format('YYYY-MM-DD')
        )
        // setProfileBody(res.result[0])
        const profile = res.result[0]
        const menu = res.result[0]?.role_menus.map((d) => fnMapMenu(d))

        const menuLength = menu.filter((item) => item)
        localStorage.setItem(RETOKEN, res.refreshToken)
        localStorage.setItem(TOKEN, res.accessToken)
        localStorage.setItem(PROFILE, JSON.stringify(profile))
        setLanguageStage('en')

        dispatch(
          updateToken(res.accessToken, res.refreshToken, profile, menuLength)
        )
        dispatch(
          updateRole(profile.roles.length > 0 ? profile.roles[0].org_id : 0)
        )
        dispatch(updateAllMenu(menuLength))
        if (data.remember) {
          localStorage.setItem(REMEMBER, JSON.stringify(data))
        } else {
          localStorage.setItem(REMEMBER, '{}')
        }
        if (menuLength.length > 0) {
          if (reDirect) {
            navigate(reDirect)
          } else {
            navigate('/')
          }
          // checkToken(profile)
        } else {
          SwalCustom({
            title: `Menu Error`,
            text: 'โปรดตรวจสอบสิทธิการเข้าถึง หรือ ติดต่อ Line OA แผนกไอที',
            confirmButtonColor: '#ffc107'
          })
        }
      } else {
        Error_false({ msg: t(res.msg) })
      }
    } catch (error) {
      setIsLogin(false)
      Error_500(error)
    }
  }
  return (
    <div
      className="d-xl-flex align-items-xl-center"
      style={{
        height: '100vh'
      }}
    >
      {isLoade && <div className="preloader-login"></div>}
      {/* <div className="preloader-login"></div> */}
      <Container fluid>
        <Row className="auth-inner m-0">
          <Col xl={6} className="order-2 order-xl-1 my-auto">
            <Image src={imgBanner} fluid />
          </Col>
          <Col
            className="px-xl-2 order-1 order-xl-2 mx-auto my-auto d-flex justify-content-center"
            xl={6}
          >
            <Card className="border-0  shadow-sm" style={{ width: '350px' }}>
              <Card.Body>
                <div className="row mt-3">
                  <div className="col-md-12 mx-auto text-center">
                    <Image src={imgJop} width={180} className="mb-4" />
                  </div>
                  <div className="col-lg-11 mx-auto">
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Form.Group className="mb-3">
                        <LabelCustom text={'Organization'} />

                        <Controller
                          name={'orgId'}
                          control={control}
                          render={({ field: { onChange, value = null } }) => (
                            <Autocomplete
                              // placeholder="Select organization"
                              options={dataOrgs}
                              value={value}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.orgId && (
                          <span className="text-danger small fw-light">
                            <BsExclamationCircle /> Please choose your
                            organization.
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <LabelCustom text={'Username'} />

                        <Controller
                          name={'username'}
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <Form.Control
                              name="Username"
                              type="text"
                              placeholder=""
                              id=""
                              value={value}
                              onChange={onChange}
                            />
                          )}
                        />

                        {errors.username && (
                          <span className="text-danger small fw-light">
                            <BsExclamationCircle /> Please enter Username.
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <LabelCustom text={'Password'} />
                        <Controller
                          name={'password'}
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <InputGroup className="">
                              <Form.Control
                                name="Password"
                                style={{ borderRight: 'none' }}
                                type={isShowPassword ? 'text' : 'password'}
                                id="inputPassword"
                                aria-describedby="passwordHelpBlock"
                                value={value}
                                onChange={onChange}
                              />
                              <InputGroup.Text
                                className="cursor-pointer"
                                onClick={() =>
                                  setIsShowPassword(!isShowPassword)
                                }
                              >
                                {' '}
                                {!isShowPassword ? (
                                  <BsFillEyeFill />
                                ) : (
                                  <BsFillEyeSlashFill />
                                )}
                              </InputGroup.Text>
                            </InputGroup>
                          )}
                        />
                        {errors.password && (
                          <span className="text-danger small fw-light">
                            <BsExclamationCircle /> Incorrect Password.
                          </span>
                        )}
                      </Form.Group>
                      <Controller
                        name={'remember'}
                        control={control}
                        render={({ field: { onChange, value = false } }) => (
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicCheckbox"
                            value={value}
                            onChange={onChange}
                          >
                            <Form.Check
                              checked={value}
                              type="checkbox"
                              label="Remember me"
                            />
                          </Form.Group>
                        )}
                      />

                      <div className="d-grid gap-2 mt-5">
                        <Button
                          disabled={isLogin}
                          className="radius-primary btn-sky"
                          type="submit"
                        >
                          {isLogin ? 'Loading...' : 'Login'}
                        </Button>
                      </div>
                    </Form>
                    <Divider>OR</Divider>
                    <div className="d-grid gap-2 mt-3">
                      <Button
                        onClick={() => {
                          navigate(`${MENU_LOGIN}-lark/3`)
                        }}
                        className="d-flex align-items-center justify-content-center gap-2"
                        type="button"
                        variant="primary"
                        style={{
                          backgroundColor: '#222222',
                          borderColor: 'black'
                        }}
                      >
                        <img src={'/icon-lark.png'} alt="Lark" width={20} />
                        <span>Login With Lark Account</span>
                      </Button>
                    </div>
                  </div>
                </div>

                <p
                  style={{ fontSize: '0.7rem' }}
                  className="fw-light text-center text-muted mt-4"
                >
                  COPYRIGHT © {new Date().getFullYear()} IT@SkyICT PCL.All
                  rights Reserved {FOOTER_VERSION} {apiBack} (API)
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default LoginPage
